import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import { saveProfile } from "../../services/PersonalService";
import { RootStoreContext } from "../../store";
import style from "./SubmitBtn.module.css";

function SubmitBtn(props) {
  const { PersonalStore } = useContext(RootStoreContext);
  const {
    profile_picture,
    gender,
    softPower,
    hardPower,
    motivation,
    igLink,
    fbLink,
    linkedInLink,
  } = PersonalStore;
  const { username, birthday, email, experience, deeds } = PersonalStore;
  // const deeds_obj = Object.fromEntries(
  //   deeds.map((item, index) => [index, item])
  // );

  return (
    <Button
      style={{
        color: "white",
        backgroundColor: "#444444",
        margin: "2% 0",
        width: "60px",
        height: "30px",
      }}
      onClick={() =>
        saveProfile({
          profile_picture: profile_picture,
          gender: gender,
          softPower: softPower,
          hardPower: hardPower,
          motivation: motivation,
          username: username,
          birthday: birthday,
          email: email,
          experience: experience,
          // deeds: deeds_obj,
          igLink: igLink,
          linkedInLink: linkedInLink,
          fbLink: fbLink,
        })
      }
    >
      <Typography variant="h8" className={style.submit}>
        {props.label}
      </Typography>
    </Button>
  );
}

export default SubmitBtn;
